import { Link } from "react-router-dom";
import { getCategoryLabel, getUnitLabel, fileUrl } from "../lib/api";
import { useI18n } from "../i18n/I18nProvider";
import { MapPin, Package } from "lucide-react";
import SaveButton from "./SaveButton";

export default function ListingCard({ listing }) {
  const { t, lang } = useI18n();
  const img = listing.image_paths?.[0];
  const priceLabel = listing.price > 0 ? `${listing.price} ${t("price.currency")}` : t("card.free");
  return (
    <div className="card-tech group flex flex-col relative" data-testid={`listing-card-${listing.id}`}>
      <Link to={`/listings/${listing.id}`} className="contents">
        <div className="aspect-square bg-[var(--surface-alt)] overflow-hidden relative">
          {img ? (
            <img src={fileUrl(img)} alt={listing.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
          ) : (
            <div className="w-full h-full grid place-items-center text-[var(--ink-500)] label-tech">{t("card.noImage")}</div>
          )}
          <div className="absolute top-3 left-3 flex gap-2">
            <span className="tag">{getCategoryLabel(listing.category, lang)}</span>
          </div>
          <div className="absolute top-3 right-3">
            <span className="tag tag-moss">{listing.quality}</span>
          </div>
          {listing.quantity_remaining === 0 && (
            <div className="absolute bottom-3 left-3">
              <span className="tag bg-[var(--ink)] text-[var(--bone)]" data-testid="card-fully-booked">{t("card.fullyBooked")}</span>
            </div>
          )}
        </div>
        <div className="p-4 border-t border-[var(--ink-200)]">
          <h3 className="font-display font-medium text-lg tracking-tight line-clamp-1">{listing.title}</h3>
          <div className="mt-2 flex items-center gap-4 text-sm text-[var(--ink-700)]">
            <span className="inline-flex items-center gap-1"><MapPin size={14} />{listing.location}</span>
            <span className="inline-flex items-center gap-1" data-testid="card-quantity">
              <Package size={14} />
              {listing.quantity_remaining !== undefined && listing.quantity_remaining < listing.quantity ? (
                <><strong>{listing.quantity_remaining}</strong>/{listing.quantity}</>
              ) : (
                <>{listing.quantity}</>
              )}{" "}{getUnitLabel(listing.unit, lang)}
            </span>
          </div>
          <div className="mt-3 flex items-center justify-between">
            <span className="label-tech">{priceLabel}{listing.distance_km != null ? ` · ${listing.distance_km} km` : ""}</span>
            <span className="label-tech text-[var(--brick)] group-hover:underline">{t("card.view")}</span>
          </div>
        </div>
      </Link>
      <div className="absolute bottom-3 right-3">
        <SaveButton listingId={listing.id} size={14} />
      </div>
    </div>
  );
}
